// @ts-expect-error untyped module
import { useEmbedContext } from '../../../hooks/useEmbedContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { useRelevantCollections } from 'marketplace-ui-common/collections/hooks/useRelevantCollections';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { StorefrontHeaderView } from 'marketplace-ui-common/storefront/components/StorefrontHeaderView';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { Fragment, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { useOfferingType } from '../../../context/OfferingTypeContext';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute';
import { getIsInApp } from '../../../selectors/app';
import { getModulesStorefrontRoute, getThemeCollectionPreviewRoute, getThemesStorefrontRoute } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function UnifiedSearchWrapper({
  children,
  isEmbedded
}) {
  if (isEmbedded) {
    return /*#__PURE__*/_jsx(MainSection, {
      paddingBlock: "300",
      color: "light",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(StorefrontHeaderView, {
    backgroundImage: "none",
    color: "white",
    divider: true,
    children: children
  });
}
export default function DesktopBrowseBar({
  hasActiveOfferingType,
  previewCollectionId
}) {
  const {
    isEmbedded
  } = useEmbedContext();
  const isPrerender = getIsPrerenderUserAgent();
  const isInApp = useSelector(getIsInApp);
  const offeringType = useOfferingType();
  const activeOfferingType = hasActiveOfferingType ? offeringType : null;
  const {
    getCollectionSlugs,
    getDisplayedCollections
  } = useRelevantCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType
  });
  const collections = getDisplayedCollections();
  const collectionSlugs = getCollectionSlugs();
  const activeCollectionRoutes = useMemo(() => collectionSlugs.map(slug => getThemesStorefrontRoute(slug)).concat(['/']), [collectionSlugs]);
  const isActiveCollectionRoute = useIsActiveRoute({
    pathname: previewCollectionId ? getThemeCollectionPreviewRoute(previewCollectionId) : activeCollectionRoutes
  }, true);
  const [dropdownOpen, setDropdownOpen] = useState(isPrerender);
  const toggleThemeDropdown = () => {
    setDropdownOpen(isOpen => !isOpen);
  };
  const getButtonUse = active => {
    return active ? 'tertiary-extra-light' : 'transparent';
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UnifiedSearchWrapper, {
      isEmbedded: isEmbedded,
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          paddingBlock: "200",
          children: !isEmbedded ? /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(RouterButton, {
              "data-test-id": "storefront-nav-themes-button",
              size: "md",
              to: getThemesStorefrontRoute('all'),
              use: getButtonUse(activeOfferingType === 'THEME'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.nav.themes"
              })
            }), /*#__PURE__*/_jsx(RouterButton, {
              "data-test-id": "storefront-nav-modules-button",
              to: getModulesStorefrontRoute(),
              use: getButtonUse(activeOfferingType === 'MODULE'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.nav.modules"
              })
            })]
          }) : /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(Dropdown, {
              buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.nav.discover"
              }),
              "data-test-id": "storefront-nav-discover-dropdown",
              open: dropdownOpen,
              onOpenChange: toggleThemeDropdown,
              children: /*#__PURE__*/_jsxs(List, {
                wrapChildren: true,
                children: [/*#__PURE__*/_jsx(RouterButton, {
                  to: getThemesStorefrontRoute(),
                  "data-test-id": "storefront-nav-collection-button::all",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "marketplace-assets-ui.storefront.nav.allCollections"
                  })
                }), collections.map(({
                  id,
                  name,
                  slug,
                  title
                }) => /*#__PURE__*/_jsx(RouterButton, {
                  to: getThemesStorefrontRoute(slug),
                  "data-test-id": `storefront-nav-collection-button::${slug}`,
                  children: /*#__PURE__*/_jsx(SanitizedText, {
                    body: title !== null && title !== void 0 ? title : name,
                    WrapperComponent: "span"
                  })
                }, id))]
              })
            }), /*#__PURE__*/_jsx(RouterButton, {
              "data-test-id": "storefront-nav-themes-button",
              to: getThemesStorefrontRoute('all'),
              use: getButtonUse(isActiveCollectionRoute),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.nav.themes"
              })
            })]
          })
        })
      })
    }), !isEmbedded && /*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      borderColor: "border-core-subtle"
    })]
  });
}